import PropTypes from 'prop-types';
import React from 'react';

import GradientBackground from './GradientBackground';

const BiomeInfoPane = ({locationInfo, children}) => {
  return (
    <div className="BiomeInfoPane">
      <GradientBackground
        startColor={locationInfo.gradientStartColor}
        endColor={locationInfo.gradientEndColor}
      >
        {children}
      </GradientBackground>
    </div>
  );
};

BiomeInfoPane.propTypes = {
  locationInfo: PropTypes.object.isRequired,
};

export default BiomeInfoPane;



// WEBPACK FOOTER //
// ./src/components/BiomeInfoPane.js